var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"journey-map-edit"},[_c('l-map',{ref:"leafmap",staticClass:"l-map",on:{"ready":_vm.mapReady}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }